import { Bar } from "react-chartjs-2";
import { useEffect, useState } from "react";
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
} from "chart.js";
import axios from "axios";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

export default function GraficaGastosPorMes({mes}) {
    const [datos, setDatos] = useState(null);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_DOMINIO}/wp-json/finanzas/v1/gastos/por-mes?mes=${mes}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        })
            .then(res => {
                if (res.data.success) {
                    setDatos(res.data.data);
                }
            })
            .catch(err => console.error(err));
    }, [mes]);

    if (!datos) return <p>Cargando gastos por mes...</p>;

    const meses = Object.keys(datos);
    const montos = Object.values(datos);

    const chartData = {
        labels: meses,
        datasets: [
            {
                label: "Gastos por mes",
                data: montos,
                backgroundColor: "#FF6384",
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { display: false },
        },
    };

    return (
        <div style={{ maxWidth: "700px", margin: "2rem auto" }}>
            <h3 style={{ textAlign: "center" }}>Gastos por mes</h3>
            <Bar data={chartData} options={options} />
        </div>
    );
}
